// extracted by mini-css-extract-plugin
export default {"main":"Stats_main__j0hLL","loading":"Stats_loading__mBPD1","stats":"Stats_stats__S5UVl"};